module.exports = __webpack_public_path__ + "static/media/ci_new.eb30f78b.png";